export const SET_DRAWER_STATE = Symbol();
export const TOGGLE_DRAWER_STATE = Symbol();
